<template>
  <div>
    <router-link class="btn m-2" :to="`/dashboard/routing`">
      Back to Routing
    </router-link>
    <div
      v-if="auth.user.userType === 'super-admin'"
      class="btn btn-info m-2"
      @click="deleteR"
    >
      Delete Routing
    </div>
    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Min Amount"
                placeholder="Min Amount"
                v-model="route.minAmount"
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Max Amount"
                placeholder="Max Amount"
                v-model="route.maxAmount"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Card Type</label>
              <select class="form-control" v-model="route.cardType">
                <option value="">Select a Card Type</option>
                <option value="A000000003">Visa</option>
                <option value="A000000004">Master Card</option>
                <option value="A000000371">Verve</option>
                <option value="A000000065">JCB</option>
                <option value="A000000025">Amex</option>
                <option value="A000000333">CUP</option>
                <option value="A000000152">Dinners</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Min Bin Range"
                placeholder="Min Bin Range"
                v-model="route.minRange"
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Max Bin Range"
                placeholder="Max Bin Range"
                v-model="route.maxRange"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Processor</label>
              <select class="form-control" v-model="route.processor">
                <option value="">Select a Processor</option>
                <option value="UPSL">UPSL</option>
                <option value="ISW">ISW</option>
                <option value="3LINE">3LINE</option>
                <option value="ZONE">ZONE</option>
                <option value="UPSL_PTSA">UPSL PTSA</option>
                <option value="NIBSS_PTSA">NIBSS PTSA</option>
                <option value="NIBSS">NIBSS</option>
              </select>
            </div>

            <div class="col-md-6">
              <label for="inlineFormInput">Alternate Processor</label>
              <select class="form-control" v-model="route.alternateProcessor">
                <option value="">Select an Alternate Processor</option>
                <option value="UPSL">UPSL</option>
                <option value="ISW">ISW</option>
                <option value="3LINE">3LINE</option>
              </select>
            </div>
          </div>

          <div class="row" v-if="auth.user.userType === 'super-admin'">
            <div class="col-md-6" v-if="route.merchantId">
              <label>Merchant </label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="route.merchantId"
                required
                disabled
              >
                <option value="">Select Merchant</option>
                <option
                  v-for="merchant in allMerchants"
                  :key="merchant.id"
                  :value="merchant._id"
                >
                  {{ merchant.merchantName }}
                </option>
              </select>
            </div>

            <div class="col-md-6" v-if="route.institutionId">
              <label>Institution</label>

              <select
                class="form-control op-border"
                id="rate-type"
                v-model="route.institutionId"
                required
                disabled
              >
                <option value="">Select Institution</option>
                <option
                  v-for="institution in allInstitutions"
                  :key="institution.id"
                  :value="institution._id"
                >
                  {{ institution.institutionName }}
                </option>
              </select>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Update
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
export default {
  data() {
    return {
      selectedMerchant: "",
      selectedInstitution: "",
      route: {},
      merchant: {},
      institution: {},
      allInstitutions: [],
    };
  },
  computed: {
    ...mapState(["loading", "terminal", "utils", "auth"]),
  },
  methods: {
    ...mapActions([
      "updateRouting",
      "deleteRouting",
      "getMerchants",
      "setNotification",
      "getInstitutions",
    ]),
    submit() {
      if (this.selectedMerchant !== "") {
        this.route.merchantId = this.selectedMerchant._id;
      }
      if (this.selectedInstitution !== "") {
        this.route.institutionId = this.selectedInstitution._id;
      }
      if (this.route.alternateProcessor) {
        this.route.alternateProcessor = this.route.alternateProcessor;
      }
      this.$confirm("Update Routing?").then(() => {
        this.updateRouting(this.route);
      });
    },
    deleteR() {
      this.$confirm("Delete Routing? Are you sure?").then(() => {
        this.deleteRouting({ id: this.route._id });
      });
    },
    async getRoute() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/routing/${this.$route.params.routeId}`,
        );

        const { route, merchant, message } = res.data;

        this.route = route;
        this.merchant = merchant;

        this.setNotification({
          type: "success",
          message,
        });
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Routes",
          });
        }
      }
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );
        const { merchants } = res.data;
        this.allMerchants = merchants;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getInstitutions() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
        );

        const institutions = res.data.institutions.docs;
        this.allInstitutions = institutions;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },
  },
  mounted() {
    this.getRoute();
    this.getMerchants();
    this.getInstitutions();
  },
};
</script>
